import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import '../css/TextEditor.css';
import AdminNavbar from './AdminNavbar';

const TextEditor = () => {
    const [content, setContent] = useState("");    // Stores the content fetched from the database
    const [error, setError] = useState(null);      // Stores any error message
    const [saveStatus, setSaveStatus] = useState(null);  // Stores the save status message
    const location = useLocation();
    const editorRef = useRef(null);
    const quillInstance = useRef(null);            // Store the Quill instance
    const { diaryId, password } = location.state || {};

    // Fetch existing content from the database
    const fetchDiaryContent = async (id) => {
        const formData = new FormData();
        formData.append('id', id);

        try {
            const response = await axios.post('https://snapcourse.in/fun/get_diary_content.php', formData);
            if (response.data.success) {
                const fetchedContent = response.data.content || "";
                setContent(fetchedContent);  // Update the state with fetched content

                // Initialize Quill and set content AFTER fetching
                if (!quillInstance.current) {
                    quillInstance.current = new Quill(editorRef.current, {
                        theme: 'snow',
                        placeholder: 'Start writing your content here...',
                        modules: {
                            toolbar: [
                                ['bold', 'italic', 'underline', 'strike'],
                                ['link', 'blockquote', 'code-block'],
                                [{ list: 'ordered' }, { list: 'bullet' }],
                                [{ header: [1, 2, 3, false] }],
                                [{ align: [] }],
                                ['clean'],
                            ],
                        },
                    });

                    // Set the fetched content into the Quill editor
                    quillInstance.current.root.innerHTML = fetchedContent;

                    // Update state on text change
                    quillInstance.current.on('text-change', () => {
                        const quillContent = quillInstance.current.root.innerHTML;
                        setContent(quillContent);
                    });
                } else {
                    // Update the Quill editor content if it was already initialized
                    quillInstance.current.root.innerHTML = fetchedContent;
                }
            } else {
                setError(response.data.message || "Failed to fetch content.");
            }
        } catch (error) {
            console.error('Error fetching diary content:', error);
            setError('Error fetching diary content.');
        }
    };

    // Fetch content when the component mounts
    useEffect(() => {
        if (diaryId) {
            fetchDiaryContent(diaryId);
        }

        return () => {
            // Properly destroy the Quill instance when unmounting
            if (quillInstance.current) {
                quillInstance.current.off('text-change');  // Remove the event listener
                quillInstance.current = null;
            }
        };
    }, [diaryId]);

    // Save the current content to the database
    const saveContentToDatabase = async () => {
        const formData = new FormData();
        formData.append('id', diaryId);
        formData.append('content', content);
        formData.append('password', password);

        try {
            const response = await axios.post('https://snapcourse.in/fun/savecontent.php', formData);
            if (response.data.success) {
                setSaveStatus("Content saved successfully!");
            } else {
                setSaveStatus(response.data.error || "Failed to save content.");
            }
        } catch (error) {
            setSaveStatus("Error saving content.");
            console.error('Error saving content:', error);
        }
    };

    const handleSaveClick = () => {
        saveContentToDatabase();
    };

    if (error) {
        return <p>{error}</p>;
    }

    return (
        <>
            <AdminNavbar />
            <div className="editor-container">
                <h1>Text Editor</h1>
                <div ref={editorRef} className="quill-editor"></div>

                <button className="save-button" onClick={handleSaveClick}>
                    Save Content
                </button>
                {saveStatus && <p>{saveStatus}</p>}
            </div>
        </>
    );
};

export default TextEditor;
